export const initialState = {
  items: [],
};

export function FETCH_ROLES_NORMALIZATION(nextState, { result }) {
  nextState.items = result;
}
